import { render, staticRenderFns } from "./DoubleLoginArea.vue?vue&type=template&id=3e7d0fc4&"
import script from "./DoubleLoginArea.vue?vue&type=script&lang=ts&"
export * from "./DoubleLoginArea.vue?vue&type=script&lang=ts&"
import style0 from "./DoubleLoginArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VForm,VRow})
